import axiosInstance from '../surveyAxiosInstance';
import type { AxiosResponse } from 'axios';

class SurveysService {
	async getSurvey(identifier: string, contactToken: string) {
		const response: AxiosResponse = await axiosInstance.get(
			`/public/surveys?surveyIdentifier=${identifier}${contactToken === 'isAdmin' ? '' : `&contactToken=${contactToken}`}`,
		);

		const survey: Survey = response.data.data.survey;
		return survey;
	}

	async saveSubmission(payload: {
		surveyIdentifier: string;
		contactToken: string;
		surveySubmissions: {
			language: Lang;
			surveySubmissionValues: Partial<SurveySubmissionValue>[];
		}[];
	}) {
		const response: AxiosResponse = await axiosInstance.post(
			`/public/surveySubmissions`,
			payload,
		);

		const survey: Survey = response.data.data.survey;
		return survey;
	}
}

// This type of exporting is intended to make sure service acts as a singleton.
export default new SurveysService();
